<script setup lang="ts">
import "@/assets/styles/footer.css";

import {ChevronRight, Mail, MapPin, Phone} from "lucide-vue-next";
</script>

<template>

  <footer class="footer">

    <div class="footer-container">

      <!-- Firma -->
      <div class="footer-column">

        <div class="footer-brand">

          <img
              src="@/assets/images/logo.png"
              alt="Logo"
              class="footer-logo"
          />

          <div>
            <h2>TestGarten</h2>
            <span>Garten- & Landschaftsbau</span>
          </div>

        </div>

        <p>
          Professioneller Garten- & Landschaftsbau
          für moderne Außenanlagen,
          Pflege und individuelle Projekte.
        </p>

      </div>

      <!-- Navigation -->
      <div class="footer-column">

        <h3>Navigation</h3>

        <nav class="footer-links">

          <a href="#home">
            <ChevronRight size="18"/>
            Home
          </a>

          <a href="#about">
            <ChevronRight size="18"/>
            Über uns
          </a>

          <a href="#services">
            <ChevronRight size="18"/>
            Leistungen
          </a>

          <a href="#references">
            <ChevronRight size="18"/>
            Referenzen
          </a>

          <a href="#reviews">
            <ChevronRight size="18"/>
            Bewertungen
          </a>

          <a href="#contact">
            <ChevronRight size="18"/>
            Kontakt
          </a>

        </nav>

      </div>

      <!-- Kontakt -->
      <div class="footer-column">

        <h3>Kontakt</h3>

        <div class="footer-contact">

          <div class="contact-item">
            <MapPin size="18"/>
            <span>Wiesbaden & Umgebung</span>
          </div>

          <div class="contact-item">
            <Phone size="18"/>
            <span>+49 123 456789</span>
          </div>

          <div class="contact-item">
            <Mail size="18"/>
            <span>info@testgarten.de</span>
          </div>

        </div>

      </div>

    </div>

    <!-- Bottom -->
    <div class="footer-bottom">

      <p>
        © 2026 TestGarten — Alle Rechte vorbehalten
      </p>

      <div class="footer-bottom-links">
        <a href="/impressum">Impressum</a>
        <a href="/datenschutz">Datenschutz</a>
      </div>

    </div>

  </footer>

</template>

<style scoped>
</style>